export const configKeys = {
  getConfig: ({
    companyId,
    configName,
    configType,
    configCategory,
    targetMapper,
  }: {
    companyId?: string;
    configName?: string;
    configType?: string;
    configCategory?: string;
    targetMapper?: string;
  }) => ['config', companyId, configName, configType, configCategory, targetMapper],
};
